import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import ModalSidebar from "../../components/ModalSidebar";
import NavigationBar from "../../components/NavigationBar";
import SideBar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";
import { getParentPath } from "../../helper";

const Dashboard = () => {
  let navigate = useNavigate();
  let params = useParams();
  const location = useLocation();
  const isParkingLayout =
    location.pathname === "/admin/parking-layout" ||
    location.pathname === "/admin/layout"
      ? true
      : false;

  const [activePath, setActivePath] = useState("dashboard");
  const [isSidebarOpen, setSidebar] = useState(false);

  useEffect(() => {
    let path =
      Object.keys(params).length === 0 // eslint-disable-line
        ? location.pathname.split("/")[location.pathname.split("/").length - 1]
        : location.pathname.split("/")[location.pathname.split("/").length - 2];

    let parentPath = getParentPath(path);
    setActivePath(parentPath);
  }, [location]); // eslint-disable-line

  const handleRoute = (path: any) => {
    setActivePath(path);
    setSidebar(false);
    navigate(`${path}`);
  };

  const handleSidebarOpen = () => {
    setSidebar(true);
  };

  return (
    <DashboardLayoutContainer>
      <SideBar onRoute={handleRoute} activePath={activePath} />
      <MobileSidebar>
        <ModalSidebar
          open={isSidebarOpen}
          onRoute={handleRoute}
          activePath={activePath}
          onCloseModal={() => setSidebar(false)}
        />
        <TopBar
          onRoute={handleRoute}
          activePath={activePath}
          onOpenSidebar={handleSidebarOpen}
        />
      </MobileSidebar>
      <ContentContainer>
        {!isParkingLayout && <NavigationBar />}
        {isParkingLayout ? (
          <FullPageContainer>
            <Outlet />
          </FullPageContainer>
        ) : (
          <PageContainer>
            <Outlet />
          </PageContainer>
        )}
      </ContentContainer>
    </DashboardLayoutContainer>
  );
};

const DashboardLayoutContainer = styled.div`
  display: flex;
  background: black;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    background: transparent;
  }
`;

const MobileSidebar = styled.div``;

const ContentContainer = styled.main`
  width: calc(100vw - 17rem);
  height: calc(100vh - 2rem);
  margin: 1rem;
  margin-left: 0;
  border-radius: 1rem;
  background: white;
  @media only screen and (max-width: 1200px) {
    width: calc(100vw - 4.5rem);
  }
  @media only screen and (max-width: 768px) {
    width: 100vw;
    height: calc(100vh - 6rem);
    margin: 0;
    border-radius: 0;
  }
`;

const PageContainer = styled.div`
  padding: 1.5rem 3rem;
  overflow-y: auto;
  height: calc(100vh - 10.5rem);
  @media only screen and (max-width: 768px) {
    padding: 0rem;
    height: calc(100vh - 9rem);
  }
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: #000000;
  }
`;

const FullPageContainer = styled.div`
  overflow-y: auto;
  height: calc(100vh - 2rem);
  @media only screen and (max-width: 768px) {
    padding: 0rem;
    height: calc(100vh - 9rem);
  }
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: #000000;
  }
`;

export default Dashboard;
